export const ENVIRONMENTS_ENUMS = {
  LOCAL: "local",
  PROD: "prod",
  DEV: "dev",
  STG: "stg",
};

const envPatterns = {
  DEV: /.*admin.ptu.uz/g,
  STG: /.*admin.ptu.uz/g,
  PROD: /.*admin.ptu.uz/g,
};

export const getCurrentEnvironment = () => {
  const nodeEnv = process.env.NODE_ENV;
  const apiHost = process.env.REACT_APP_API_HOST;

  console.log("nodeEnv", nodeEnv);
  console.log("apiHost", apiHost);

  if (nodeEnv === "production") {
    console.log("PROD based on NODE_ENV");
    return ENVIRONMENTS_ENUMS.PROD;
  }

  if (nodeEnv === "development") {
    console.log("DEV based on NODE_ENV");
    return ENVIRONMENTS_ENUMS.DEV;
  }

  // Fallback to host pattern detection
  if (envPatterns.PROD.test(apiHost || "")) {
    console.log("PROD based on API host");
    return ENVIRONMENTS_ENUMS.PROD;
  }

  if (envPatterns.DEV.test(apiHost || "")) {
    console.log("DEV based on API host");
    return ENVIRONMENTS_ENUMS.DEV;
  }

  if (envPatterns.STG.test(apiHost || "")) {
    console.log("STG based on API host");
    return ENVIRONMENTS_ENUMS.STG;
  }

  console.log("LOCAL (fallback)");
  return ENVIRONMENTS_ENUMS.LOCAL;
};
